"use strict";
import { hasClass, find, on } from "@elements/dom-utils";
import {onFind} from "@elements/init-modules-in-scope";

const selectors = {
    divider: '.js-divider'
};

export function init() {
    const firstDivider = find(selectors.divider);

    if(firstDivider && hasClass('divider--top-right', firstDivider)) {
        if(window.matchMedia('(max-width: 767px)').matches) {
            setCSSVariable('--hero-height-additional-offset', '-11vw');
        } else {
            setCSSVariable('--hero-height-additional-offset', '-4.5vw');
        }
    }

    function setCSSVariable(name, value) {
        const variableBase = find('body');
        variableBase && variableBase.style.setProperty(name, value);
    }
}

